import BaseModel from './BaseModel'

export default class CarModel extends BaseModel {
    get schema() {
        return {
            id: ['id', undefined, value => value],
            name: ['name', undefined, value => value],
            numberPlate: ['numberPlate', undefined, value => value],
            //
            bodyType: ['bodyType', undefined, value => value],
            clientFullName: ['clientFullName', undefined, value => value],
            color: ['color', undefined, value => value],
            engineCapacity: ['engineCapacity', undefined, value => value],
            mileage: ['mileage', undefined, value => parseInt(value)],
            model: ['model', undefined, value => value],
            vin: ['vin', undefined, value => value],
            yearManufacture: ['yearManufacture', undefined, value => parseInt(value)],
        }
    };

    static attributeLabels = {
        id: 'ID',
        name: 'Название',
        numberPlate: 'Номерной знак',
        //
        bodyType: 'Тип кузова',
        clientFullName: 'ФИО клиента',
        color: 'Цвет',
        engineCapacity: 'Объем двигателя',
        mileage: 'Пробег, км',
        model: 'Модель',
        vin: 'VIN',
        yearManufacture: 'Год выпуска',
    }
}
